// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3Cua8","dragIcon":"SortableItem_dragIcon__3GrDi","disabled":"SortableItem_disabled__3tppL"};